import { Toast } from '@sobrus-com/sobrus-design-system';
import { AuthContext } from 'Context';
import { memo, useContext } from 'react';
import Header from './Header';

const ProtectedHeader = memo(() => {
  const { loading, error } = useContext(AuthContext);
  if (loading === false) {
    if (!error) {
      return (
        <>
          <Toast />
          <Header />
        </>
      );
    }
    return null;
  }
  return null;
});

export default ProtectedHeader;
